import React, { useState } from "react";
import LazyLoad from "react-lazy-load";
import { useDispatch, useSelector } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import { selectShowWorkspaceWeight } from "../../state/config/config.selector";
import { userToken } from "../../state/user/user.selector";
import type { MyWorkspaceMetadata } from "../../state/workspaces/types";
import * as workspacesActions from "../../state/workspaces/workspaces.actions";
import Styles from "./SimpleWorkspaceCard.module.css";
import CustomWorkspacePreview from "./WorkspaceCard/CustomWorkspacePreview";
import DefaultWorkspacePreview from "./WorkspaceCard/DefaultWorkspacePreview";

interface SimpleWorkspaceCardProps {
  myWorkspaceMetadata: MyWorkspaceMetadata;
  thumbnailPreviewUrl?: string;
}

const SimpleWorkspaceCard = ({
  children,
  myWorkspaceMetadata,
  thumbnailPreviewUrl,
}: React.PropsWithChildren<SimpleWorkspaceCardProps>) => {
  const dispatch = useDispatch();

  const token = useSelector(userToken);
  const showWorkspaceWeight = useSelector(selectShowWorkspaceWeight);
  const canEditLabels = myWorkspaceMetadata.myPermissions.canAdmin;

  const [isVisible, setIsVisible] = useState(false);

  const showEditLabelPrompt = () =>
    dispatch(
      workspacesActions.activateDashboardOption({
        optionType: DashboardOption.ADD_LABEL,
        workspaceId: myWorkspaceMetadata.workspaceId,
      }),
    );

  return (
    <div className={Styles.simpleWorkspaceCard}>
      <div className={Styles.thumbnailContainer}>
        <LazyLoad>
          <CustomWorkspacePreview
            canEditLabels={canEditLabels}
            myWorkspaceMetadata={myWorkspaceMetadata}
            setIsVisible={setIsVisible}
            showEditLabelPrompt={showEditLabelPrompt}
            showWorkspaceWeight={showWorkspaceWeight}
            thumbnailPreviewUrl={thumbnailPreviewUrl}
            token={token}
          />
        </LazyLoad>
        {!isVisible && (
          <DefaultWorkspacePreview
            canEditLabels={canEditLabels}
            myWorkspaceMetadata={myWorkspaceMetadata}
            showEditLabelPrompt={showEditLabelPrompt}
            showWorkspaceWeight={showWorkspaceWeight}
          />
        )}
      </div>
      <div className={Styles.thumbnailFooter} style={{ maxWidth: "200px" }}>
        {children}
      </div>
    </div>
  );
};

export default SimpleWorkspaceCard;
